import $apiPublic from 'api/apiPublic'
import $apiPrivate from 'api/apiPrivate'

// Расшифровка партнерского кода - ПЕРЕДАЧА КЛИКА
const sendClick = async (data) => {
  const response = await $apiPublic.post('/clicks/create', data);
  return response
}

// Получение данных пользователя по Партнерке
const getUserPartnershipData = async () => {
  const response = await $apiPrivate.get('/user/partner_info');
  return response
}

// Получение списка платежных систем для вывода партнерских
const getWithdrawMethods = async (data) => {
  const response = await $apiPrivate.get('/user/partner/payments', data);
  return response
}

// Создание заявки на вывод партнерки
const withdrawReward = async (data) => {
  const response = await $apiPrivate.post('/user/partner/createwithdrawal', data);
  return response
}

const getStatisticsServers = async (data) => {
  const response = await $apiPrivate.post('/user/partner/infodata', data);
  return response
}

// Партнёрская информация по уровням
const getStatisticsClients = async () => {
  const response = await $apiPrivate.get('/user/partner/levels');
  return response
}

// Партнёрская сеть
const getNetwork = async () => {
  const response = await $apiPrivate.get('/user/partner_network/');
  // const response = { data: fakeNetwork };
  return response
}

// Получение партнерских промокодов пользователя
const getPromocodes = async () => {
  const response = await $apiPrivate.get('/user/balance/promocodes');
  return response
}

// Доступные скидки для создания и использования в промокоде
const getDiscounts = async () => {
  const response = await $apiPrivate.get('/user/balance/available_discount');
  return response
}

// Создание партнерского промокода
const createPromocode = async (data) => {
  const response = await $apiPrivate.post('/user/balance/promocode', data);
  return response
}

// Удаление партнерского промокода
const deletePromocode = async (id) => {
  const response = await $apiPrivate.delete(`user/balance/promocode/${id}`);
  return response
}

export default {
  sendClick,

  getUserPartnershipData,

  getWithdrawMethods,
  withdrawReward,

  getStatisticsServers,
  getStatisticsClients,

  getNetwork,

  getPromocodes,
  getDiscounts,
  createPromocode,
  deletePromocode,
}